export default {
  loadCouponsSuccess: ({ allCoupons }, payload) => {
    allCoupons.items = payload.data;
    allCoupons.pagination.totalItems = payload.recordsTotal;
  },
  loadCouponNameExists: (state, payload) => {
    state.newCoupon.couponNameExists = payload.data.couponExists;
  },
  setPagination: ({ allCoupons }, payload) => {
    allCoupons.pagination = payload;
  },
  setLoadingCoupons: (state, payload) => {
    state.loadingCoupons = payload;
  },
  setLoadingCreatingCoupon: (state, payload) => {
    state.newCoupon.loadingCreatingCoupon = payload;
  },
  nextStep: state => {
    state.el += 1;
  },
  previousStep: state => {
    state.el -= 1;
  },
  setStep: (state, payload) => {
    state.el = payload;
  },
  setLoadingCouponNameCheck: (state, payload) => {
    state.newCoupon.loadingCouponNameCheck = payload;
  },
  resetCouponNameExists: state => {
    state.newCoupon.couponNameExists = false;
  },
  setCouponProducts: (state, payload) => {
    state.couponProducts = payload;
  },
  setCouponSearchProducts: (state, payload) => {
    state.couponSearchProducts = payload;
  },
  setCouponDeleted: (state, payload) => {
    state.allCoupons.items[payload].status = 'deleting';
  },
};
